import {
  Pagination,
  PaginationProvider,
  useDebounce,
} from '@bbl-digital/snorre-v2'
import { useQueryBoardDocumentsWithSearchTextQuery } from 'shared/microServices/portalDocuments/portalDocuments.service'
import { useFileuploadPickerContext } from '../../context/useFileuploadPickerContext'
import ArchiveFileItem from '../ArchiveFileItem'
import Loading from './Loading'
import NoContent from './NoContent'
import ErrorContent from './ErrorContent'
import { useEffect } from 'react'

const ArchiveFileSearchList = () => {
  const {
    archiveSearchListPagination,
    setArchiveSearchListPagination,
    archiveSearchText,
    setArchiveSearchText,
  } = useFileuploadPickerContext()

  const debouncedSearchText = useDebounce(archiveSearchText, 300)

  useEffect(() => {
    setArchiveSearchText(debouncedSearchText)
  }, [debouncedSearchText, setArchiveSearchText])

  const { data, isLoading, isFetching, isError } =
    useQueryBoardDocumentsWithSearchTextQuery({
      take: archiveSearchListPagination.pageSize,
      skip:
        archiveSearchListPagination.page * archiveSearchListPagination.pageSize,
      searchText: debouncedSearchText,
    })

  const files = data?.documents
  const total = data?.totalCount

  const showLoading = isLoading || isFetching
  const showFiles = files && files.length > 0 && !showLoading && !isError
  const showNoContent =
    (!files || files.length === 0) && !showLoading && !isError
  const showPagination = files && total > 0 && !isError
  const showError = isError && !showLoading

  return (
    <PaginationProvider
      initialState={{
        total: total,
        pageSize: archiveSearchListPagination.pageSize,
        pageIndex: archiveSearchListPagination.page,
        pageOptions: [5, 10, 20],
      }}
    >
      <div>
        {showLoading && (
          <Loading pageSize={archiveSearchListPagination.pageSize} />
        )}
        {showFiles &&
          files?.map((file) => <ArchiveFileItem key={file.id} file={file} />)}
        {showNoContent && <NoContent text="Fant ingen vedlegg" />}
        {showError && (
          <ErrorContent text="Noe gikk galt ved henting av vedlegg fra arkivet" />
        )}
      </div>
      {showPagination && (
        <Pagination
          onPageSizeChange={(pageSize: number) =>
            setArchiveSearchListPagination({
              ...archiveSearchListPagination,
              pageSize: pageSize,
              page: 0,
            })
          }
          onPageChange={(e) =>
            setArchiveSearchListPagination({
              ...archiveSearchListPagination,
              page: e,
            })
          }
        />
      )}
    </PaginationProvider>
  )
}

export default ArchiveFileSearchList
